import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-726bfe7b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btn-cntr" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass('icon-' + _ctx.iconName)
    }, null, 2),
    _createElementVNode("span", {
      class: _normalizeClass(["icon__hover", 'icon-' + _ctx.iconName + '_h'])
    }, null, 2),
    _createElementVNode("span", {
      class: _normalizeClass(["icon__disable", 'icon-' + _ctx.iconName + '_d'])
    }, null, 2)
  ]))
}